import Cookies from 'js-cookie';
import isUUID from 'validator/lib/isUUID';
import ky from 'ky';
import Bowser from 'bowser';

import {
  APP_ID,
  MEMBER_APP_ID,
  APP_VERSION,
  TRACKING_LOG_VERSION,
  TRACKING_API_NAME__LOG_TRACKING,
  TRACKING_COOKIE_AGE__CHOCOMEMBER_ID_AGE,
} from './constants';

/**
 * @see {@link https://docs.google.com/spreadsheets/d/1OMhlNt-5jTx0Z-LNWI3O_3EbijNopKBE_SdsHPU3Jmw/edit#gid=0}
 */
export default async function getGeneralFields() {
  const timestamp = Date.now();
  const cookieEnabled = navigator.cookieEnabled;
  const accessToken = cookieEnabled ? Cookies.get(process.env.MEMBER_COOKIE_KEY__ACCESS_TOKEN) : undefined;
  const sessionId = cookieEnabled ? Cookies.get(process.env.TRACKING_COOKIE_KEY__SESSION_ID) : undefined;
  const clientId = cookieEnabled ? Cookies.get(process.env.TRACKING_COOKIE_KEY__CLIENT_ID) : undefined;

  let os;
  const uaParseResult = Bowser.parse(window.navigator.userAgent);

  switch (uaParseResult?.platform?.type) {
    case 'desktop':
      os = 'desktop_web';
      break;
    case 'tablet':
    case 'mobile':
      os = 'mobile_web';
      break;
  }

  let chocomember_id;

  if (accessToken) {
    const chocomemberId = Cookies.get(process.env.MEMBER_COOKIE_KEY__CHOCOMEMBER_ID);

    if (chocomemberId && isUUID(chocomemberId)) {
      chocomember_id = chocomemberId;
    } else {
      const res = await ky.get(`${process.env.MEMBER_API_HOST}/account/profile`, {
        searchParams: { appId: MEMBER_APP_ID },
        headers: {
          Authorization: accessToken,
        },
        throwHttpErrors: false,
      });

      if (res.ok) {
        const { AccountId } = await res.json();

        if (AccountId && isUUID(AccountId)) {
          Cookies.set(process.env.MEMBER_COOKIE_KEY__CHOCOMEMBER_ID, AccountId, {
            expires: TRACKING_COOKIE_AGE__CHOCOMEMBER_ID_AGE,
            domain: process.env.TRACKING_COOKIE_DOMAIN,
            sameSite: 'lax',
          });

          chocomember_id = AccountId;
        }
      }
    }
  }

  return {
    session_id: sessionId,
    installation_id: clientId,
    chocomember_id,
    page_id: location.href,

    app_id: APP_ID,
    app_ver_id: APP_VERSION,
    os,
    // os_version: undefined,
    // ip: undefined,
    cookie_enable: String(cookieEnabled),

    timestamp,
    log_ver_id: TRACKING_LOG_VERSION,
    api: TRACKING_API_NAME__LOG_TRACKING,
  };
}
